import { render } from "./ButtonUp.vue?vue&type=template&id=7b993942&scoped=true"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"

import "./ButtonUp.vue?vue&type=style&index=0&id=7b993942&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b993942"]])

export default __exports__